import React from 'react'

export const organization = {
    '@type': 'Organization', '@id': 'https://fleeka.ru/#organization',
    name: 'Флика', alternateName: 'FLEEKA', url: 'https://fleeka.ru/',
    description: 'Информационный сервис подбора водителя для междугородней поездки. Флика принимает заявки и передаёт их водителям; не является перевозчиком или автопарком.',
    telephone: '+79507007071', email: 'taxifleeka@yandex.ru',
    logo: 'https://fleeka.ru/logo/fleeka-logo-new.png',
    sameAs: ['https://t.me/taxiFLEEKA', 'https://yandex.ru/maps/org/flika/173242094663/'],
    address: {'@type': 'PostalAddress', streetAddress: 'площадь Ленина, 2А', addressLocality: 'Россошь', addressRegion: 'Воронежская область', addressCountry: 'RU'}
}

export default function Trust() {
    return <section className="fleeka-trust65" id="contacts" aria-labelledby="fleeka-contacts-title">
        <div className="fleeka-trust65__inner">
            <div>
                <p className="fleeka-trust65__eyebrow">О СЕРВИСЕ</p>
                <h2 id="fleeka-contacts-title">Флика — связь с водителем для межгорода</h2>
                <p>Принимаем заявки и передаём их водителям. Флика — информационный сервис, не перевозчик и не автопарк. Поездку выполняет отдельный водитель или перевозчик.</p>
                <p>Калькулятор показывает предварительную стоимость. До подтверждения поездки согласуйте водителя, точные адреса, время подачи, багаж и итоговую цену. Платные дороги оплачиваются отдельно.</p>
                <p><strong>Оплата:</strong> наличные и безналичная оплата. Удобный способ и реквизиты уточните при согласовании поездки.</p>
                <a href="https://yandex.ru/maps/org/flika/173242094663/" target="_blank" rel="noopener noreferrer">Флика на Яндекс Картах: офис и отзывы <span aria-hidden="true">↗</span></a>
                <p className="fleeka-trust65__muted">Уже ездили с нами? Поделитесь честным отзывом о своём опыте.</p>
            </div>
            <div className="fleeka-trust65__office">
                <h3>Контакты и приём в офисе</h3>
                <address>Воронежская область, Россошь,<br />площадь Ленина, 2А</address>
                <p><strong>Пн–пт, 10:00–15:00</strong><br />Время приёма в офисе</p>
                <p><a href="tel:+79507007071">8 950 700-70-71</a><br /><a href="mailto:taxifleeka@yandex.ru">taxifleeka@yandex.ru</a><br /><a href="https://t.me/taxiFLEEKA" target="_blank" rel="noopener noreferrer">Telegram @taxiFLEEKA</a></p>
                <div className="fleeka-trust65__identity"><p>Владелец сервиса:<br /><strong>Бунчук Валерий Сергеевич</strong><br />Самозанятый · ИНН 362709453177</p></div>
            </div>
        </div>
    </section>
}
